import { Component, inject } from '@angular/core';
import { AlertService } from '@core/services/alert.service';

@Component({
  selector: 'app-alert-container',
  templateUrl: './alert-container.html',
  styleUrl: './alert-container.scss',
})
export class AlertContainer {
  protected readonly alertService = inject(AlertService);
}
